import React, { useEffect, useState } from "react";
// import { useIntl } from 'react-intl'
// import { PageTitle } from '../../../_metronic/layout/core'

// import {
//   ListsWidget3,
//   TilesWidget4,
//   TilesWidget5,
// } from '../../../_metronic/partials/widgets'
import { ListRecordCount } from './list/listRecordCount'
import { InquiryVisaCount } from './list/InquiryVisaCount'
import { FilterForm } from './list/FilterForm'
import { ListFollowupRecord } from './list/listFollowupRecord'

import { DashboardQueryResponce } from './core/_models'
import { getdashborddata } from './core/_requests'
import { object } from "yup";
import { SelectedDataProvider } from './list/SelectedDataContext';
import { ToDoListRecord } from "./list/toDoListRecord";
import { AssignTaskRecord } from "./list/assignTaskRecord";
import { InquiryPointList } from "./list/InquiryPointList";
type Props = {
  // heading?: string
  // total_count?: string
  // route_heading?: string
  // count?: any
  // name?: string
}

const DashboardPage: React.FC<Props> = () => {
  // const { selectedName } = useName(); 
  // console.log(`Selected Name: ${selectedName}`);
  const [dashboardinquiry, setDashboardInquiry] = useState<DashboardQueryResponce>() as any;
  const [dashboardinquiryloading, setDashboardInquiryLoading] = useState(false);
  const [filterCount, setFilterCount] = useState<string>("");
  useEffect(() => {
    getdashborddata('').then((result) => {
      setDashboardInquiry(result);
      setDashboardInquiryLoading(true);
    });
  }, []);
  const handleFilterSubmit = (filters: any) => {
    const query = Object.keys(filters)
      .map((key) => `${key}=${filters[key]}`)
      .join("&");
    setFilterCount(query);
    getdashborddata(query).then((result) => {
      setDashboardInquiry(result);
    });
  };
  return (
    <>
      <SelectedDataProvider>
        <div>
          <div className='row g-5 g-xl-12 mt-2'>
            <div className='col-xl-12'>
              <div className='row gx-5 gx-xl-40 mb-5 mb-xl-4'>
                <div className='col-xl-3'>
                  {/* < TilesWidget2 className='card-xl-stretch mb-5 mb-xl-8' />  */}
                  <div className='row gx-5 gx-xl-8 mb-5 mb-xl-8 pt-lg-20'>
                    <div className='col-xl-6 '>
                      <InquiryVisaCount
                        className='card-xxl-stretch bg-primary'
                        svgIcon='/media/icons/duotune/general/gen025.svg'
                        titleClass='text-white'
                        descriptionClass='text-white'
                        iconClass='svg-icon-white'
                        href={process.env.REACT_APP_HOME_PAGE + "dashboard"}
                        title={dashboardinquiry?.data?.inquirycount}
                        description='Total Inquiries'
                      />
                    </div>
                    <div className='col-xl-6 '>
                      <InquiryVisaCount
                        className='card-xxl-stretch bg-body'
                        svgIcon='/media/icons/duotune/general/gen002.svg'
                        titleClass='text-dark'
                        descriptionClass='text-muted'
                        iconClass='svg-icon-success'
                        href={process.env.REACT_APP_HOME_PAGE + "visadashboard"}
                        title={dashboardinquiry?.data?.visafilecount}
                        description='Total Visa File'
                      />
                    </div>

                  </div>
                </div>
                <div className='col-xl-9'>
                  {dashboardinquiryloading &&
                    <FilterForm onFilterSubmit={handleFilterSubmit} className='card-xl-stretch' />
                  }
                </div>
              </div>
            </div>
          </div>
          <div className='row gy-5 gx-8'>
            {dashboardinquiry?.data?.['inquiryproducts'] && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <ListRecordCount heading="PRODUCT TYPE" data={dashboardinquiry?.data?.['inquiryproducts']} name="product_Id" count={dashboardinquiry?.data?.['inquiry_product_total']} emptyarray={dashboardinquiry?.data?.['productemptyArray']} emptycount={dashboardinquiry?.data?.['productempty']} filter={filterCount} className='card-xxl-stretch mb-xl-3' />
              </div>
            )
            }
            {dashboardinquiry?.data?.['inquirycategoryproducts'] && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <ListRecordCount heading="PRODUCT CATEGORY" data={dashboardinquiry?.data?.['inquirycategoryproducts']} name="product_cate_Id" count={dashboardinquiry?.data?.['inquiry_productcategory_total']} emptyarray={dashboardinquiry?.data?.['productemptyArray']} emptycount={dashboardinquiry?.data?.['productempty']} filter={filterCount} className='card-xxl-stretch mb-xl-3' />
              </div>
            )
            }
            {dashboardinquiry?.data?.['inquirystatues'] && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <ListRecordCount heading="INQUIRY STATUS" data={dashboardinquiry?.data?.['inquirystatues']} name="inq_status_Id" count={dashboardinquiry?.data?.['inquiry_status_total']} emptyarray={dashboardinquiry?.data?.['inquirystatusemptyArray']} emptycount={dashboardinquiry?.data?.['inquirystatusempty']} filter={filterCount} className='card-xxl-stretch mb-xl-3' />
              </div>
            )}
            {dashboardinquiry?.data?.['inquirytypes'] && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <ListRecordCount heading="INQUIRY TYPE" data={dashboardinquiry?.data?.['inquirytypes']} name="inq_type_Id" count={dashboardinquiry?.data?.['inquiry_types_total']} emptyarray={dashboardinquiry?.data?.['inquirytypeemptyArray']} emptycount={dashboardinquiry?.data?.['inquirytypeempty']} filter={filterCount} className='card-xxl-stretch mb-xl-3' />
              </div>
            )
            }
            {dashboardinquiry?.data?.['inquirysources'] && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <ListRecordCount heading="INQUIRY SOURCE" data={dashboardinquiry?.data?.['inquirysources']} name="inq_source_Id" count={dashboardinquiry?.data?.['inquiry_sources_total']} emptyarray={dashboardinquiry?.data?.['inquirysourceemptyArray']} emptycount={dashboardinquiry?.data?.['inquirysourceempty']} filter={filterCount} className='card-xxl-stretch mb-xl-3' />
              </div>
            )}

            {dashboardinquiry?.data?.['inquirysubsources'] && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <ListRecordCount heading="INQUIRY SUBSOURCE" data={dashboardinquiry?.data?.['inquirysubsources']} name="inq_subsource_Id" count={dashboardinquiry?.data?.['inquiry_subsources_total']} emptyarray={dashboardinquiry?.data?.['inquirysubsourceemptyArray']} emptycount={dashboardinquiry?.data?.['inquirysubsourceempty']} filter={filterCount} className='card-xxl-stretch mb-xl-3' />
              </div>
            )}

            {dashboardinquiry?.data?.['inquiryexecutives'] && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <ListRecordCount heading="EXECUTIVE STATISTICS" data={dashboardinquiry?.data?.['inquiryexecutives']} name="inq_Exe_Id" count={dashboardinquiry?.data?.['inquiry_assignto_total']} emptyarray={dashboardinquiry?.data?.['inquiryexecutiveemptyArray']} emptycount={dashboardinquiry?.data?.['inquiryexecutiveempty']} filter={filterCount} className='card-xxl-stretch mb-xl-3' />
              </div>
            )}
            {(dashboardinquiry?.data?.['inquiry_with_followup'] != undefined || dashboardinquiry?.data?.['inquiry_without_followup'] != undefined) && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <ListFollowupRecord heading="INQUIRY FOLLOWUP" name="followup_option" filter={filterCount} followup_past_active={dashboardinquiry?.data?.['inquiry_past_active_followup']} followup_yes={dashboardinquiry?.data?.['inquiry_with_followup']} followup_no={dashboardinquiry?.data?.['inquiry_without_followup']} followup_active={dashboardinquiry?.data?.['inquiry_active_followup']} followup_deactive={dashboardinquiry?.data?.['inquiry_deactive_followup']} today_followup={dashboardinquiry?.data?.['inquiry_today_followup']} today_task={dashboardinquiry?.data?.['inquiry_today_task']} className='card-xxl-stretch mb-xl-3' />
              </div>
            )}

            {(dashboardinquiry?.data?.['inquiry_today_pending_task_todo'] != undefined) && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <ToDoListRecord heading="TO DO LIST" name="inq_task_option" filter={filterCount} inq_today_pending={dashboardinquiry?.data?.['inquiry_today_pending_task_todo']} inq_past_pending={dashboardinquiry?.data?.['inquiry_past_pending_task_todo']} inq_future_pending={dashboardinquiry?.data?.['inquiry_future_pending_task_todo']} inq_completed_task={dashboardinquiry?.data?.['inquiry_completed_task_todo']} className='card-xxl-stretch mb-xl-3' />
              </div>
            )}

            {(dashboardinquiry?.data?.['inquiry_today_pending_task_assigntask'] != undefined) && (
              <div className='col-lg-6 col-xl-4 col-xxl-3'>
                <AssignTaskRecord heading="ASSIGN TASK" name="inq_assign_task_option" filter={filterCount} inq_today_pending={dashboardinquiry?.data?.['inquiry_today_pending_task_assigntask']} inq_past_pending={dashboardinquiry?.data?.['inquiry_past_pending_task_assigntask']} inq_future_pending={dashboardinquiry?.data?.['inquiry_future_pending_task_assigntask']} inq_completed_task={dashboardinquiry?.data?.['inquiry_completed_task_assigntask']} className='card-xxl-stretch mb-xl-3' />
              </div>
            )}


            {dashboardinquiry?.data?.['point_field'] && (
              <div className='col-lg-4 col-xl-4 col-xxl-3'>
                <InquiryPointList heading="USER POINTS" data={dashboardinquiry?.data?.['point_field']} count={dashboardinquiry?.data?.['point_field_total']} filter={filterCount} name="user_point" className='card-xxl-stretch mb-xl-3' />
              </div>
            )}
          </div>
        </div>
      </SelectedDataProvider>

    </>
  )
}

const DashboardWrapper = () => {
  // const intl = useIntl()


  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle> */}
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
